import { defineMessages } from 'react-intl';
export default defineMessages({
    absolutePressure: {
        id: 'metrics.absolutePressure',
        defaultMessage: 'Absolute pressure'
    },
    airDensity: {
        id: 'metrics.airDensity',
        defaultMessage: 'Air density'
    },
    airGap: {
        id: 'metrics.airGap',
        defaultMessage: 'Air gap'
    },
    apparentTemperature: {
        id: 'metrics.apparentTemperature',
        defaultMessage: 'Apparent temperature'
    },
    AQI: {
        id: 'metrics.AQI',
        defaultMessage: 'AQI'
    },
    AQI_24H: {
        id: 'metrics.AQI_24H',
        defaultMessage: '24h AQI'
    },
    avg: {
        id: 'metrics.avg',
        defaultMessage: 'Avg.'
    },
    avg_wind: {
        id: 'metrics.avg_wind',
        defaultMessage: 'Mean wind'
    },
    beaufort: {
        id: 'metrics.beaufort',
        defaultMessage: 'Beaufort'
    },
    blackGlobeTemperature: {
        id: 'metrics.blackGlobeTemperature',
        defaultMessage: 'Black globe temp.'
    },
    boilerOn: {
        id: 'metrics.boilerOn',
        defaultMessage: 'Boiler ON'
    },
    boilerOnInHours: {
        id: 'metrics.boilerOnInHours',
        defaultMessage: 'Boiler ON (hours)'
    },
    cloudCover: {
        id: 'metrics.cloudCover',
        defaultMessage: 'Cloud cover'
    },
    co2: {
        id: 'metrics.co2',
        defaultMessage: 'CO2'
    },
    conductivity: {
        id: 'metrics.conductivity',
        defaultMessage: 'Conductivity'
    },
    dailyPrecipitation: {
        id: 'metrics.dailyPrecipitation',
        defaultMessage: 'Daily precipitation'
    },
    dailyRain: {
        id: 'metrics.dailyRain',
        defaultMessage: 'Daily rain'
    },
    degreeDayShort: {
        id: 'metrics.degreeDayShort',
        defaultMessage: 'DD'
    },
    depth: {
        id: 'metrics.depth',
        defaultMessage: 'Depth'
    },
    depthSensors: {
        id: 'metrics.depthSensors',
        defaultMessage: 'Depth sensors'
    },
    dewPoint: {
        id: 'metrics.dewPoint',
        defaultMessage: 'Dew point'
    },
    distance: {
        id: 'metrics.distance',
        defaultMessage: 'Distance'
    },
    downTrend: {
        id: 'metrics.downTrend',
        defaultMessage: 'down'
    },
    ET: {
        id: 'metrics.ET',
        defaultMessage: 'Evapotranspiration'
    },
    etToday: {
        id: 'metrics.etToday',
        defaultMessage: 'ET today'
    },
    feelsLike: {
        id: 'metrics.feelsLike',
        defaultMessage: 'Feels like'
    },
    feelsLikeWithFormula: {
        id: 'metrics.feelsLikeWithFormula',
        defaultMessage: 'Feels like ({formula})'
    },
    frostPoint: {
        id: 'metrics.frostPoint',
        defaultMessage: 'Frost point'
    },
    gust: {
        id: 'metrics.gust',
        defaultMessage: 'Gust'
    },
    gustDirection: {
        id: 'metrics.gustDirection',
        defaultMessage: 'Gust direction'
    },
    hail: {
        id: 'metrics.hail',
        defaultMessage: 'Hail'
    },
    heatIndex: {
        id: 'metrics.heatIndex',
        defaultMessage: 'Heat index'
    },
    heatingDegreeDays: {
        id: 'metrics.heatingDegreeDays',
        defaultMessage: 'Heating degree days'
    },
    heatingPower: {
        id: 'metrics.heatingPower',
        defaultMessage: 'Heating power'
    },
    humidex: {
        id: 'metrics.humidex',
        defaultMessage: 'Humidex'
    },
    humidity: {
        id: 'metrics.humidity',
        defaultMessage: 'Humidity'
    },
    lastLightningImpact: {
        id: 'metrics.lastLightningImpact',
        defaultMessage: 'Last impact'
    },
    lastMeasure: {
        id: 'metrics.lastMeasure',
        defaultMessage: 'Last measure'
    },
    leafSensors: {
        id: 'metrics.leafSensors',
        defaultMessage: 'Leaf sensors'
    },
    leafWetness: {
        id: 'metrics.leafWetness',
        defaultMessage: 'Leaf wetness'
    },
    lightningDistance: {
        id: 'metrics.lightningDistance',
        defaultMessage: 'Distance'
    },
    lightningStrikeCount: {
        id: 'metrics.lightningStrikeCount',
        defaultMessage: 'Lightning strike count'
    },
    lightningStrikeDistance: {
        id: 'metrics.lightningStrikeDistance',
        defaultMessage: 'Lightning strike distance'
    },
    max: {
        id: 'metrics.max',
        defaultMessage: 'Max.'
    },
    max_gust: {
        id: 'metrics.max_gust',
        defaultMessage: 'Max. gust'
    },
    maxToday: {
        id: 'metrics.maxToday',
        defaultMessage: 'Max today'
    },
    min: {
        id: 'metrics.min',
        defaultMessage: 'Min.'
    },
    noise: {
        id: 'metrics.noise',
        defaultMessage: 'Noise'
    },
    normalizedHeatingCoefficient: {
        id: 'metrics.normalizedHeatingCoefficient',
        defaultMessage: 'Normalized heating coefficient'
    },
    outdoorTemperature: {
        id: 'metrics.outdoorTemperature',
        defaultMessage: 'Outdoor temperature'
    },
    PM_1: {
        id: 'metrics.PM_1',
        defaultMessage: 'PM1'
    },
    PM_10: {
        id: 'metrics.PM_10',
        defaultMessage: 'PM10'
    },
    PM_2P5: {
        id: 'metrics.PM_2P5',
        defaultMessage: 'PM2.5'
    },
    precipitation: {
        id: 'metrics.precipitation',
        defaultMessage: 'Precipitation'
    },
    pressure: {
        id: 'metrics.pressure',
        defaultMessage: 'Pressure'
    },
    rain: {
        id: 'metrics.rain',
        defaultMessage: 'Rain'
    },
    rainDurationValue: {
        id: 'metrics.rainDurationValue',
        defaultMessage: 'Rain duration: {duration}'
    },
    rainRate: {
        id: 'metrics.rainRate',
        defaultMessage: 'Rain rate'
    },
    relativePressure: {
        id: 'metrics.relativePressure',
        defaultMessage: 'Relative pressure'
    },
    setPoint: {
        id: 'metrics.setPoint',
        defaultMessage: 'Setpoint'
    },
    snow: {
        id: 'metrics.snow',
        defaultMessage: 'Snow'
    },
    snowfall: {
        id: 'metrics.snowfall',
        defaultMessage: 'Snowfall'
    },
    soilMoisture: {
        id: 'metrics.soilMoisture',
        defaultMessage: 'Moisture'
    },
    soilSensors: {
        id: 'metrics.soilSensors',
        defaultMessage: 'Soil sensors'
    },
    soilWaterTension: {
        id: 'metrics.soilWaterTension',
        defaultMessage: 'Soil water tension'
    },
    solarEnergy: {
        id: 'metrics.solarEnergy',
        defaultMessage: 'Solar energy'
    },
    solarRadiation: {
        id: 'metrics.solarRadiation',
        defaultMessage: 'Solar radiation'
    },
    speed: {
        id: 'metrics.speed',
        defaultMessage: 'Speed'
    },
    stableTrend: {
        id: 'metrics.stableTrend',
        defaultMessage: 'stable'
    },
    sum: {
        id: 'metrics.sum',
        defaultMessage: 'Sum'
    },
    temperature: {
        id: 'metrics.temperature',
        defaultMessage: 'Temperature'
    },
    temperatureSensors: {
        id: 'metrics.temperatureSensors',
        defaultMessage: 'Temperature & humidity sensors'
    },
    temperatureShort: {
        id: 'metrics.temperatureShort',
        defaultMessage: 'Temp.'
    },
    thsw: {
        id: 'metrics.thsw',
        defaultMessage: 'THSW'
    },
    thw: {
        id: 'metrics.thw',
        defaultMessage: 'THW'
    },
    upTrend: {
        id: 'metrics.upTrend',
        defaultMessage: 'up'
    },
    uv: {
        id: 'metrics.uv',
        defaultMessage: 'UV'
    },
    visibility: {
        id: 'metrics.visibility',
        defaultMessage: 'Visibility'
    },
    weatherCondition: {
        id: 'metrics.weatherCondition',
        defaultMessage: 'Weather condition'
    },
    wetBulbGlobeTemperature: {
        id: 'metrics.wetBulbGlobeTemperature',
        defaultMessage: 'Wet bulb globe temp.'
    },
    wetBulbTemperature: {
        id: 'metrics.wetBulbTemperature',
        defaultMessage: 'Wet bulb temp.'
    },
    wind: {
        id: 'metrics.wind',
        defaultMessage: 'Wind'
    },
    windChill: {
        id: 'metrics.windChill',
        defaultMessage: 'Wind chill'
    },
    windDirection: {
        id: 'metrics.windDirection',
        defaultMessage: 'Wind direction'
    },
    windRun: {
        id: 'metrics.windRun',
        defaultMessage: 'Wind run'
    },
    windRunDescription: {
        id: 'metrics.windRunDescription',
        defaultMessage: 'Wind run is the total distance the wind travels over a period of time'
    },
    windSpeed: {
        id: 'metrics.windSpeed',
        defaultMessage: 'Wind speed'
    }
});
